import { TFunction } from '@lyearn/i18n';
import { DEFAULT_ASSIGNMENT_RESTRICTION } from '@/components/Form/components/AssignmentRestriction/consts';
import QuizSettingsEntity from '@/modules/corporate/modules/quiz/entity/QuizSettings';
import { getQuizPassingPercentage } from '@/modules/corporate/modules/quiz/views/QuizEditor/utils';
import { getInitialQuestionState } from '@/modules/corporate/modules/quiz/views/QuizEditor/utils/questions';
import {
  CreateQuizInput,
  LanguageEnum,
  QuestionApplicableOnEnum,
  QuestionTypeEnum,
  QuizQuestionInput,
  ResourceSubTypeEnum,
  ResourceTypeEnum,
} from '@/types/schema';
import { getRandomCardImage } from '@/utils/cardImage';

export const getCreateQuizInput = ({
  name,
  t,
  currentSubWorkspace,
  enableAssignmentRestriction,
  isQuizSyncSkillScoreEnabled,
  questions,
  defaultLanguageType,
}: {
  name: string;
  t: TFunction;
  currentSubWorkspace: string | null;
  enableAssignmentRestriction: boolean;
  questions?: QuizQuestionInput[];
  isQuizSyncSkillScoreEnabled: boolean;
  defaultLanguageType?: LanguageEnum;
}): CreateQuizInput => {
  const quiz: CreateQuizInput = {
    name,
    subType: ResourceSubTypeEnum.Static,
    questions: questions ?? [],
    passingPercentage: getQuizPassingPercentage(),
    cover: getRandomCardImage(ResourceTypeEnum.Quiz),
    subWorkspaceIds: currentSubWorkspace ? [currentSubWorkspace] : undefined,
    settings: {
      ...QuizSettingsEntity.getDefaultRetakeSettings(),
      syncSkillScore: isQuizSyncSkillScoreEnabled ? true : undefined,
    },
    assignmentRestriction: enableAssignmentRestriction ? DEFAULT_ASSIGNMENT_RESTRICTION : undefined,
    ...(defaultLanguageType ? { defaultLanguageType } : {}),
  };
  const questionInput = getInitialQuestionState(
    QuestionTypeEnum.SingleSelect,
    t,
    QuestionApplicableOnEnum.Quiz,
    currentSubWorkspace,
  );

  if (questionInput && quiz.questions?.length === 0) {
    quiz.questions.push({ questionInput });
  }

  return quiz;
};
